import { ControlledAutocomplete, ControlledAutocompleteProps } from '@if/mui'
import { EBankFailureCode, getEBankFailureCodeList } from '@src/types/constants'
import { JSX, memo } from 'react'
import { Control, FieldPathByValue, FieldValues } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface NsfStatusSelectProps<TFieldValues extends FieldValues = FieldValues>
  extends Omit<ControlledAutocompleteProps<TFieldValues, false, false, false>, 'control' | 'name' | 'options'> {
  control: Control<TFieldValues>
  name: FieldPathByValue<TFieldValues, EBankFailureCode | null>
}

const NsfStatusSelectComponent = <TFieldValues extends FieldValues = FieldValues>({
  control,
  name,
  label,
  disabled,
  ...props
}: NsfStatusSelectProps<TFieldValues>) => {
  const { t } = useTranslation()

  return (
    <ControlledAutocomplete
      control={control}
      name={name}
      label={label ?? t('loan.payment.changeStatusPayment.nsfStatus')}
      options={getEBankFailureCodeList() as never[]}
      getOptionLabel={(option: EBankFailureCode | null) => (option ? t(`enum.bankFailureCode.${option}`) : '')}
      {...props}
    />
  )
}

// Type-safe memoization that preserves generic signature
const NsfStatusSelect = memo(NsfStatusSelectComponent) as <TFieldValues extends FieldValues = FieldValues>(
  props: NsfStatusSelectProps<TFieldValues>,
) => JSX.Element

export default NsfStatusSelect
